import { LinearProgress } from '@material-ui/core';
import Button from '@mui/material/Button';
import { RouteWidgetBaseParameters } from '@pages/AdditionalServices/tabs/DeliveryForm/types';
import useDelivery from '@pages/AdditionalServices/tabs/DeliveryForm/useDelivery';
import { SelectCargoParametersQueryResponse } from '@services/requests/routeCalculator/cargoConverterService/SelectCargoParametersQuery';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { CargoSelectionResultList } from '../CargoSelectionResultList';
import { CargoSelectionResultStyledContainer } from './StyledComponent';

interface CargoSelectionResultProps {
  isSelectionLoading: boolean;
  isSelectingError: boolean;
  isActionsDisabled: boolean;
  selectedParams: SelectCargoParametersQueryResponse['data'] | null;
  BaseData: RouteWidgetBaseParameters;
  mainLanguage: string;
  onCloseDialog: () => void;
}

function CargoSelectionResult({
  isSelectionLoading,
  selectedParams,
  isActionsDisabled,
  BaseData,
  mainLanguage,
  isSelectingError,
  onCloseDialog,
}: CargoSelectionResultProps) {
  const { useRouteParams } = useDelivery();
  const setRouteParams = useRouteParams().setState;

  const { t } = useTranslation('Common');

  const applySelectedCargoParametersHandler = () => {
    if (!selectedParams || (!!selectedParams.errorMsg && !selectedParams.conversationCargos)) {
      return;
    }

    switch (selectedParams.conversationCargos.cargoType) {
      case 'container':
        const { container_type = '' } = BaseData.containers[0];
        setRouteParams((prevState) => ({
          ...prevState,
          containerParameters: {
            ...prevState.containerParameters,
            containerParameters: selectedParams.conversationCargos.containerParameters.map((c) => ({
              ...c,
              containerType: container_type,
            })),
          },
        }));
        break;
      case 'truck':
        setRouteParams((prevState) => ({
          ...prevState,
          truckParameters: {
            ...prevState.truckParameters,
            truckParameters: selectedParams.conversationCargos.truckParameters,
          },
        }));
        break;
    }

    onCloseDialog();
  };

  return (
    <CargoSelectionResultStyledContainer>
      {isSelectionLoading && !isSelectingError && <LinearProgress />}
      {isSelectingError && !isSelectionLoading && (
        <span className="selection-error">
          {t('Common:CargoSelection.SelectionDialog.SelectionError')}
        </span>
      )}
      {selectedParams !== null && !!selectedParams.conversationCargos && !isSelectingError && (
        <div className="selection-result-wrapper">
          <div className="selection-result-control">
            <span className="selection-result-title">
              {t('Common:CargoSelection.SelectionDialog.SelectionResultTitle')}
            </span>
            <Button
              onClick={applySelectedCargoParametersHandler}
              className={'selection-result-apply-btn'}
              variant={'contained'}
              color={'primary'}
              size="medium"
              disabled={isActionsDisabled}
            >
              {t('Common:CargoSelection.SelectionDialog.ApplySelectionParamsButton')}
            </Button>
          </div>
          <CargoSelectionResultList
            selectedCargo={selectedParams.conversationCargos}
            BaseData={BaseData}
            mainLanguage={mainLanguage}
          />
        </div>
      )}
    </CargoSelectionResultStyledContainer>
  );
}

export { CargoSelectionResult };
